// Importando o axios para chamadas de api
import axios from "axios";

export const GET_DADOS_USUARIO = "GET_DADOS_USUARIO";

export const getDadosUsuario = () => async (dispatch) => {
  await axios.get("/dados_usuario").then((resp) => {
    // Dados do usuario
    dispatch({
      type: GET_DADOS_USUARIO,
      data: resp.data,
    });
  });
};

// Action para determinar a cor secundaria do site
export const USUARIO_SET_COR_FAVORITA = "USUARIO_SET_COR_FAVORITA";
export const usuarioSetCorFavorita = (cor) => ({
  type: USUARIO_SET_COR_FAVORITA,
  data: cor,
});
